import { connect } from 'react-redux';
import SearchPanel from './SearchPanel';
import { instantSearch, updateFilters } from '../../actions/search';
import { getInstrumentFacetFilter } from '../../utils/search-utils';

const mapState = (state, props) => {
  const results = state.search.instantResults || {};
  const { filters } = state.search || {};
  const { facets, hits, query, userData } = results || {};
  const facetInstruments = facets ? facets.instrument : {};
  const instruments = getInstrumentFacetFilter(facetInstruments, query, filters.instrument);
  if (userData && hits.length) {
    hits.concat(userData);
  }
  return {
    ...props,
    instruments,
    hits,
    query,
  };
};
const mapDispatch = { instantSearch, updateFilters };

export default connect(mapState, mapDispatch)(SearchPanel);
